// extracted by mini-css-extract-plugin
export default {"main":"FormatCert_main__-DavR","formats":"FormatCert_formats__70ddT","format_cont":"FormatCert_format_cont__SBLHd"};